/* global G */
import { curry, PlatformEvent } from 'lib/util'
import sequenceComponentFindProxy from 'lib/sequence/component/children/find'
import processScannedCode from 'app/camera/event/processScannedCode'
import { get } from 'lib/sequence/component/state/value'

/**
 * Get Value And Process Code Event Handler
 *
 *
 *
 * @param {Gaia.AppModule.Spec} module    current module
 * @param {Gaia.Component.Spec} component component that triggered the event
 * @param {Gaia.PlatformEvent} event      the event object
 * @returns {Promise<Object|boolean|*|null>}
 */
const getValueAndProcessCode = async (module, component, event) => {
  const actionComponent = module[G.STATE][G.ACTION][G.COMPONENT]
  const { content } = sequenceComponentFindProxy(actionComponent)

  const value = get(content)
  const sanitizedValue = value.replaceAll(' ', '').toUpperCase()

  try {
    return value
      ? await processScannedCode(module, component, new PlatformEvent(event, {
        value: sanitizedValue.length > 8
          ? value
          : sanitizedValue,
      }))
      : null
  } catch (e) {
    console.error(e)
  }

  return null
}

export default curry(getValueAndProcessCode)
